import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoDocumentosInformacionfiscalPeriodosArchivosRecibosar {
  idProyecto
  recibosar
  periodo
  ejercicio
  onChange
}

module.component('fanProyectoDocumentosInformacionfiscalPeriodosArchivosRecibosar', {
  controller: FanProyectoDocumentosInformacionfiscalPeriodosArchivosRecibosar,
  template,
  bindings: {
    idProyecto: '<',
    recibosar: '<',
    periodo: '<',
    ejercicio: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/documentos/informacionfiscal/periodos/archivos/recibosar/component.js